import React from 'react';
import { FeatureGuide } from '@nile/components';
import { NavToggle } from '@nile/reports/src/modules/home/components/utils';
import {
  DisplayText,
  Heading,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import {
  PDF_REPORT,
  DATA_REPORT,
  EFFICIENCY_REPORT
} from '@nile/reports/src/modules/home/constants';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

const ReportInfoToolbar = (props) => {
  const {
    activeView,
    reportType,
    activeViewName,
    lastUpdatedTime,
    isTvDashboard
  } = props;
  let guideName = 'report';
  if (reportType === PDF_REPORT && activeViewName === 'default') {
    guideName = 'defaultpdfreport';
  }
  if (reportType === DATA_REPORT) {
    guideName = 'datareport';
  }
  if (reportType === EFFICIENCY_REPORT) {
    guideName = 'efficiencyreport';
  }
  return (
    <div className="flex">
      <Heading element="h1">
        <div className="flex">
          {!isTvDashboard && (
            <div className="flex center">
              <div className="mr-20" onClick={props.toggleNavMenu}>
                <NavToggle />
              </div>
            </div>
          )}
          <div className="ml-64">
            <Tippy
              html={
                !isEmpty(activeView?.description) ? (
                  <div className="p10 bg-white card-border">
                    <TextStyle>
                      {activeView?.reportType === EFFICIENCY_REPORT ? (
                        <FormattedMessage id={activeView?.description || ''} />
                      ) : (
                        activeView?.description
                      )}
                    </TextStyle>
                  </div>
                ) : (
                  <></>
                )
              }
              allowHTML
              theme="light"
              position="bottom"
              className="fximp"
            >
              <div
                className={`flex actr ${
                  activeView?.reportType === EFFICIENCY_REPORT ? 'w900' : 'w350'
                }`}
              >
                <div className="ellipsis cursor-default">
                  {activeView?.reportType === EFFICIENCY_REPORT ? (
                    <FormattedMessage id={activeView?.name || ''} />
                  ) : (
                    activeView?.name
                  )}
                </div>
                {!isEmpty(activeView?.description) && !isTvDashboard && (
                  <div className="flex-center mlr10">
                    <SVGIcon name="MenuBurgerSquare" size="lg" />
                  </div>
                )}
              </div>
            </Tippy>
            {!isTvDashboard && <FeatureGuide featureName={guideName} article />}
          </div>
          {isTvDashboard && (
            <div className="fx actr">
              <DisplayText size="medium">
                {' '}
                <TextStyle variation="subdued">
                  <FormattedMessage id="admin.home.lastUpdatedAt" />{' '}
                  {lastUpdatedTime}
                </TextStyle>
              </DisplayText>
            </div>
          )}
        </div>
      </Heading>
    </div>
  );
};
export default ReportInfoToolbar;
